export default __webpack_public_path__ + "static/media/skeletons_types_table.b09e11ba.png";